
const QUALITY_STEPS = [1, 0.98, 0.96, 0.94, 0.9, 0.8, 0.7, 0.5, 0.3, 0.1, 0.05];

/**
 * 导出 Canvas 中的图像。如果图像大小大于指定的最大大小，将会进行 JPEG 压缩
 * @param {HTMLCanvasElement} canvas
 */
export async function exportCanvasImage(canvas, maxSize = 1 * 1024 * 1024) {
	let qualitySteps = QUALITY_STEPS.slice();
	let type = 'image/png', quality = 1;
	while (true) {
		const blob = await toBlob(canvas, type, quality);
		if (blob.size < maxSize) {
			if (process.env.NODE_ENV == 'development') {
				console.info(`Image size is ${Math.round(blob.size / 1024)} KB in ${type} quality ${quality * 100}%, ok.`);
			}
			return { type, blob, quality };
		}
		if (qualitySteps.length === 0) {
			throw new Error('无法压缩图片到少于指定的大小：' + maxSize);
		}
		if (process.env.NODE_ENV == 'development') {
			console.info(`Image size is ${Math.round(blob.size / 1024)} KB in ${type} quality ${quality * 100}%, zipping...`);
		}
		type = 'image/jpeg';
		quality = qualitySteps.shift();;
	}
	return null;
}

/**
 * @param {HTMLCanvasElement} canvas
 * @return {Promise<Blob>}
 */
export async function toBlob(canvas, type, quality) {
	return new Promise((resolve, reject) => {
		canvas.toBlob(resolve, type, quality);
	});
}

if (typeof window === 'object' && !HTMLCanvasElement.prototype.toBlob) {
	Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
		value: function (callback, type, quality) {
			var binStr = atob(this.toDataURL(type, quality).split(',')[1]);
			var len = binStr.length;
			var arr = new Uint8Array(len);

			for (var i = 0; i < len; i++) {
				arr[i] = binStr.charCodeAt(i);
			}

			callback(new Blob([arr], { type: type || 'image/png' }));
		}
	});
}



// WEBPACK FOOTER //
// ./lib/helpers/exportCanvasImage.js